module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"select.company_type.placeholder.default":"เลือกประเภทศูนย์บริการ"}}')
  delete Component.options._Ctor
}
